import { render, staticRenderFns } from "./InsHeader.vue?vue&type=template&id=e6d32caa&scoped=true&"
import script from "./InsHeader.vue?vue&type=script&lang=ts&"
export * from "./InsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./InsHeader.vue?vue&type=style&index=0&id=e6d32caa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d32caa",
  null
  
)

export default component.exports